// Mirrors the extMap in server/s3.js getPresignedPutUrl — keep these in sync.
export const ACCEPTED_IMAGE_TYPES = [
  'image/png', 'image/gif', 'image/jpg', 'image/jpeg', 'image/webp',
];

export const ACCEPTED_VIDEO_TYPES = [
  'video/mp4', 'video/mpeg', 'video/quicktime', 'video/webm',
  'video/x-ms-wmv', 'video/ogg', 'video/3gpp', 'video/x-msvideo',
];

// True when a stored S3 key or URL points at a video. Banner fields can hold
// either an image or a video (a legacy Actor bannerImg, a Filmmaker banner).
const VIDEO_EXTS = ['.mp4', '.mov', '.avi', '.wmv', '.flv', '.webm', '.m4v'];
export const isVideoKey = (key) => Boolean(key) && VIDEO_EXTS.some((ext) => key.toLowerCase().includes(ext));

export const IMAGE_ACCEPT = ACCEPTED_IMAGE_TYPES.join(',');
export const VIDEO_ACCEPT = ACCEPTED_VIDEO_TYPES.join(',');

export const FRIENDLY_IMAGE_LIST = 'JPG, PNG, GIF, or WEBP';
const FRIENDLY_VIDEO_LIST = 'MP4, MPEG, MOV, WEBM, WMV, OGG, 3GP, or AVI';

// Hard cap on video uploads. Size, not resolution: a well compressed 4K trailer
// is fine to serve, while a 1080p ProRes master is several gigabytes. 300 MB
// rejects uncompressed masters and passes a few minutes of compressed footage.
// ponytail: client-side guard only. Uploads go straight to S3 on a presigned
// PUT, so the server never sees the bytes. Real enforcement needs a presigned
// POST with a content-length-range policy.
export const MAX_VIDEO_BYTES = 300 * 1024 * 1024;

// Returns a friendly error string if the file's type isn't supported, or null if it's fine.
export const validateMediaFile = (file, kind) => {
  if (!file) return null;
  const accepted = kind === 'video' ? ACCEPTED_VIDEO_TYPES : ACCEPTED_IMAGE_TYPES;
  if (!accepted.includes(file.type)) {
    const friendlyList = kind === 'video' ? FRIENDLY_VIDEO_LIST : FRIENDLY_IMAGE_LIST;
    return `"${file.name}" isn't a supported file type. Please use one of: ${friendlyList}.`;
  }

  if (kind === 'video' && file.size > MAX_VIDEO_BYTES) {
    const sizeInMb = Math.round(file.size / (1024 * 1024));
    return `"${file.name}" is ${sizeInMb} MB, over the 300 MB limit. Please export a compressed version and upload that instead.`;
  }

  return null;
};
